import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

type PasswordEditModalProps = {
  onHide: VoidFunction;
  onSubmit: (password: string) => void;
  visible: boolean;
};

export const PasswordEditModal = (props: PasswordEditModalProps) => {
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");

  const reset = () => {
    setNewPassword("");
  };

  return (
    <Dialog
      className={"w-3"}
      header={"Modifier le mot de passe"}
      position={"right"}
      visible={props.visible}
      onHide={() => {
        props.onHide();
        reset();
      }}
    >
      <div className={"flex flex-column"}>
        <span className={"p-float-label w-full align-self-center"}>
          <Password
            inputId={"new-password"}
            inputStyle={{ width: "100%" }}
            className={"w-full"}
            feedback={false}
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
            }}
            toggleMask
          />
          <label htmlFor="new-password">{t("label.new-password")}</label>
        </span>

        <Button
          className={"align-self-end mt-5 w-5"}
          icon={"pi pi-save"}
          label={t("button.save")}
          onClick={() => {
            props.onHide();
            props.onSubmit(newPassword);
            reset();
          }}
        />
      </div>
    </Dialog>
  );
};
